import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'cnslib-btn-icon',
  template: `<img [src]="icon" alt="button icon image" loading="lazy" width="16" height="19" />`,
  styleUrls: ['../cta-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BtnIconComponent {
  @Input() icon: string;
}
